import PerfomanceIndicator from './PerformanceIndicator';

export default PerfomanceIndicator;
